import {convertFromServerString} from "../../../util/datetime";

/** Queue TargetValue while a test run has not finished writing files. */
export const TEST_RUN_NOT_FINISHED = 'Not Finished';

/** Queue TargetValue once IntegrationTestHandler has claimed the row. */
export const TEST_RUN_RUNNING = 'Running';

export type TTestRunStatus = 'inprogress' | 'completed' | 'failed';

export interface ITestRunFields {
    exported?: string | null
    lasterror?: string | null
    targetvalue?: string | null
    registered?: string | null
}

export function testRunStatus(run: ITestRunFields): TTestRunStatus {
    if (!run.exported) {
        return 'inprogress';
    }
    if ((run.lasterror ?? '').trim()) {
        return 'failed';
    }
    return 'completed';
}

export function canDownloadTestRun(run: ITestRunFields | null | undefined): boolean {
    const value = (run?.targetvalue ?? '').trim();
    return value.length > 0 && value !== TEST_RUN_NOT_FINISHED && value !== TEST_RUN_RUNNING;
}

export function formatTestRunDate(value: string | null | undefined): string {
    if (!value) {
        return '—';
    }
    const parsed = convertFromServerString(value);
    if (!parsed.isValid()) {
        return '—';
    }
    return parsed.format('DD/MM/YYYY HH:mm:ss');
}

/** Duration of a finished run as hh:mm:ss (exported − registered). */
export function formatTestRunDuration(registered: string | null | undefined, exported: string | null | undefined): string {
    if (!registered || !exported) {
        return '00:00:00';
    }
    const start = convertFromServerString(registered);
    const end = convertFromServerString(exported);
    if (!start.isValid() || !end.isValid()) {
        return '00:00:00';
    }
    const totalSeconds = Math.max(0, Math.floor(end.diff(start) / 1000));
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    const pad = (n: number) => String(n).padStart(2, '0');
    return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
}
